import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import { FaWarehouse } from "react-icons/fa6";
import '../../css/custom-scrollbar.css';
import { Base_Url, getpincode } from '../../../config/config'
import { toast } from 'react-toastify';

import {
    FaIdCard,
    FaAddressCard,
    FaMapMarkerAlt,
    FaUndo,
    FaTimes,
    FaEdit,
    FaSave,
} from 'react-icons/fa';


const schema = z.object({ 
    Name: z.string()
        .min(1, "Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabetic characters"),

    email: z.string()
        .email("Invalid email address"),
    phone: z.string()
        .length(10, "Phone number must be exactly 10 digits")
        .regex(/^\d+$/, "Phone number must be numeric"),
    contact_person: z.string()
        .min(1, "contact_person is required")
        .regex(/^[a-zA-Z\s]+$/, "contact_person must only contain alphabetic characters"),
    date: z.string().min(1, "Add Date is required"),
    address: z.string().min(1, "Address is required"),
    pincode: z.string()
        .length(6, "Pincode must be exactly 6 characters")
        .regex(/^\d+$/, "Pincode must be numeric"),
    city: z.string()
        .min(1, "City is required")
        .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
    state: z.string()
        .min(1, "State is required")
        .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
    country: z.string()
        .min(1, "Country is required")
        .regex(/^[A-Za-z\s]+$/, "Country must only contain letters and spaces"),
    registerName: z.string()
        .min(1, "Register Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Register Name must only contain alphabetic characters"),
    returnAddress: z.string().optional(),
});


const B2bViewWarehouse = ({ isopen, onClose, warehouse, onUpdate }) => {
    const { isDarkMode } = useMyContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditId, isSetEditId] = useState(true);
    const [isEditEmail, isSetEditEmail] = useState(true);
    const { register, handleSubmit, formState: { errors }, setValue, reset, getValues } = useForm({
        resolver: zodResolver(schema),
    });

    useEffect(() => {
        if (warehouse) {
            reset({
                Id: warehouse.id || '',
                Name: warehouse.name || '',
                email: warehouse.email || '',
                phone: warehouse.phone_number || '',
                contact_person: warehouse.contact_person || '',
                date: warehouse.created_at || '',
                address: warehouse.address || '',
                pincode: warehouse.pin_code || '',
                city: warehouse.city || '',
                state: warehouse.state || '',
                country: warehouse.country || '',
                registerName: warehouse.name || '',
                returnAddress: warehouse.ret_address || '',
            });
        }
    }, [warehouse, reset]);

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleClose = () => {
        setIsEditMode(false);
        onClose();
    };

    const hanldeAllEditFileds = () => {
        setIsEditMode(!isEditMode);
    }

    // Submit handler for save
    const onSubmit = (data) => {
        // Create updated warehouse object
        const updatedWarehouse = {
            ...warehouse,
            name: data.Name,
            email: data.email,
            phone_number: data.phone,
            contact_person: data.contact_person,
            created_at: data.date,
            address: data.address,
            pin_code: data.pincode,
            city: data.city,
            state: data.state,
            country: data.country,
            ret_address: data.returnAddress,
        };

        // Call the onUpdate callback to update parent state
        if (onUpdate) {
            onUpdate(updatedWarehouse);
        }

        toast.success("Warehouse updated successfully!");
        setIsEditMode(false);
        onClose();
    };

    const fetchPincodeData = async (pincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];
                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
                setValue("city", city);
                setValue("state", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }
            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const fetchreturnPincodeData = async (returnPincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];
                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
                setValue("returnCity", city);
                setValue("returnState", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }
            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;
        if (['pincode', 'phone', 'return-pincode'].includes(id)) {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
            if (id === 'return-pincode' && filteredValue.length === 6) {
                fetchreturnPincodeData(filteredValue);
            }
            if (id === 'pincode' && filteredValue.length === 6) {
                fetchPincodeData(filteredValue);
            }
        }
        if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    // ── Compact style helpers ──
    const sectionWrap = `p-2 rounded-lg border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/5'}`;
    const cardWrap = `p-1.5 rounded ${isDarkMode ? 'bg-black/30' : 'bg-white/50'}`;
    const labelClass = `block text-[9px] font-semibold uppercase tracking-wider mb-0.5 ${isDarkMode ? 'text-white/60' : 'text-black/60'}`;
    const inputClass = (hasError) =>
        `w-full px-2 py-1 text-[10px] border rounded transition-all focus:outline-none focus:ring-1 disabled:cursor-not-allowed disabled:opacity-60
        ${hasError ? 'border-black/60 bg-white/10' : isDarkMode ? 'border-white/20 bg-black/20 text-white' : 'border-black/20 bg-white/30 text-black'}
        ${isDarkMode ? 'focus:ring-white/40 focus:border-white/40' : 'focus:ring-black/40 focus:border-black/40'}`;

    return (
        <Dialog
            open={isopen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                className: `rounded-xl overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`
            }}
        >
            <DialogTitle className={`relative bg-emerald-500 !py-2.5 !px-4 ${isDarkMode ? ' border-b border-white/10' : ' border-b border-black/10'}`}>
                <h2 className={`text-xs font-bold font-sans flex items-center ${isDarkMode ? 'text-white' : 'text-white'}`}>
                    <FaWarehouse color="white" className="mr-2" size={14} />
                    Warehouse Details
                </h2>
                <IoIosCloseCircle color="white"
                    className={`absolute top-2.5 right-3 cursor-pointer hover:scale-110 transition-transform ${isDarkMode ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black'}`}
                    size={18}
                    onClick={handleClose}
                />
            </DialogTitle>

            <DialogContent className={`custom-scrollbar !p-0 ${isDarkMode ? 'bg-black text-white' : 'bg-white text-black'}`} style={{ maxHeight: '75vh' }}>
                <div className="p-3.5">
                    <form className="space-y-2.5 font-sans" onSubmit={handleSubmit(onSubmit, onErrors)}>

                        {/* Primary Information Section */}
                        <div className={sectionWrap}>
                            <h3 className={`text-[10px] font-bold mb-1.5 flex items-center uppercase tracking-wider ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                                <FaIdCard color="blue" className="mr-1.5" size={10} />
                                Primary Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>ID</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.Id)}
                                        {...register('Id')}
                                        disabled={isEditId}
                                    />
                                    {errors.Id && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.Id.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Name</label>
                                    <input
                                        type="text"
                                        id="facility-name"
                                        className={inputClass(errors.Name)}
                                        {...register('Name')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.Name && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.Name.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Contact Information Section */}
                        <div className={sectionWrap}>
                            <h3 className={`text-[10px] font-bold mb-1.5 flex items-center uppercase tracking-wider ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                                <FaAddressCard color="blue" className="mr-1.5" size={10} />
                                Contact Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Email</label>
                                    <input
                                        type="email"
                                        className={inputClass(errors.email)}
                                        {...register('email')}
                                        disabled={isEditEmail}
                                    />
                                    {errors.email && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.email.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Contact Person</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.contact_person)}
                                        {...register('contact_person')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.contact_person && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.contact_person.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5 mt-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Phone</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        className={inputClass(errors.phone)}
                                        {...register('phone')}
                                        maxLength={10}
                                        disabled={!isEditMode}
                                    />
                                    {errors.phone && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.phone.message}</p>}
                                </div>
                                <div className={cardWrap}>
                                    <label className={labelClass}>Add Date</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.date)}
                                        {...register('date')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.date && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.date.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Address Information Section */}
                        <div className={sectionWrap}>
                            <h3 className={`text-[10px] font-bold mb-1.5 flex items-center uppercase tracking-wider ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                                <FaMapMarkerAlt color="blue" className="mr-1.5" size={10} />
                                Address Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Address</label>
                                    <input
                                        type="text"
                                        id="address"
                                        className={inputClass(errors.address)}
                                        {...register('address')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.address && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.address.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Pincode</label>
                                    <input
                                        type="text"
                                        id="pincode"
                                        className={inputClass(errors.pincode)}
                                        {...register('pincode')}
                                        onChange={handleInputChange}
                                        maxLength={6}
                                        disabled={!isEditMode}
                                    />
                                    {errors.pincode && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.pincode.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5 mt-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        className={inputClass(errors.city)}
                                        {...register('city')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.city && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.city.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        className={inputClass(errors.state)}
                                        {...register('state')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.state && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.state.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-1.5 mt-1.5">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Country</label>
                                    <input
                                        type="text"
                                        id='country'
                                        className={inputClass(errors.country)}
                                        {...register('country')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.country && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.country.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Register Name</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.registerName)}
                                        {...register('registerName')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.registerName && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.registerName.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Return Address Section */}
                        <div className={sectionWrap}>
                            <h3 className={`text-[10px] font-bold mb-1.5 flex items-center uppercase tracking-wider ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                                <FaUndo color="blue" className="mr-1.5" size={10} />
                                Return Address Details
                            </h3>
                            <div className={cardWrap}>
                                <label className={labelClass}>Return Address</label>
                                <input
                                    type="text"
                                    id="returnAddress"
                                    className={inputClass(errors.returnAddress)}
                                    {...register('returnAddress')}
                                    disabled={!isEditMode}
                                />
                                {errors.returnAddress && <p className="text-black/60 dark:text-white/60 text-[9px] mt-0.5">{errors.returnAddress.message}</p>}
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex gap-2 pt-1">
                            <button
                                type="button"
                                onClick={hanldeAllEditFileds}
                                className={`py-1.5 px-3 rounded text-[10px] font-semibold transition-colors flex items-center border ${
                                    isEditMode 
                                        ? isDarkMode 
                                            ? 'border-white/30 text-white hover:bg-white/10' 
                                            : 'border-black/30 text-black hover:bg-black/10'
                                        : isDarkMode
                                            ? 'bg-white text-black hover:bg-white/90 border-white'
                                            : 'bg-blue-600 text-white hover:bg-black/90 '
                                }`}
                            >
                                {isEditMode ? (
                                    <>
                                        <FaTimes color='red' className="mr-1.5" size={10} /> Cancel
                                    </>
                                ) : (
                                    <>
                                        <FaEdit color="white" className="mr-1.5" size={10} /> Edit
                                    </>
                                )}
                            </button>

                            {(isEditMode && isEditId && isEditEmail) && (
                                <button
                                    type="submit"
                                    className={`py-1.5 px-3 rounded text-[10px] font-semibold transition-colors flex items-center ${
                                        isDarkMode
                                            ? 'bg-white text-black hover:bg-white/90'
                                            : 'bg-blue-600 text-white hover:bg-black/90'
                                    }`}
                                >
                                    <FaSave className="mr-1.5" size={10} /> Save
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </DialogContent>
        </Dialog>
    );
};


export default B2bViewWarehouse;